<template>
  <v-app id="cheerfulgive-login">
    <v-main>
      <v-form ref="form">
        <!-- LOGO與標題 -->
        <v-container fluid>
          <images-logo class="mx-auto d-block" />

          <div class="text-center">
            <span class="title primary--text text-h4 pb-2">
              {{ $t("login") }}
            </span>
          </div>
        </v-container>
        <v-container fluid>
          <v-row justify="center">
            <v-col cols="10" sm="6">
              <!-- 統一編號 -->
              <div class="text-h6 d-flex align-center mb-2">
                <icon-user class="cheerfulgive-icon" />
                {{ $t("ubn") }}
              </div>
              <v-text-field
                id="ubn"
                v-model="ubn"
                :rules="ubnRules"
                required
                outlined
                validate-on-blur
                :placeholder="$t('pleaseInputUbn')"
              />

              <!-- 電子信箱 -->
              <div class="text-h6 d-flex align-center mb-2">
                <icon-mail class="cheerfulgive-icon" />
                {{ $t("email") }}
              </div>
              <v-text-field
                id="email"
                v-model="email"
                :rules="emailRules"
                outlined
                validate-on-blur
                :placeholder="$t('pleaseInputEmail')"
              />

              <!-- 密碼 -->
              <div class="text-h6 d-flex align-center mb-2">
                <icon-lock-closed class="cheerfulgive-icon" />
                {{ $t("password") }}
              </div>
              <v-text-field
                id="password"
                :rules="passwordRules"
                v-model="password"
                outlined
                validate-on-blur
                :type="isVisiblePwd ? 'text' : 'password'"
                :placeholder="$t('pleaseInputPassword')"
                :append-icon="isVisiblePwd ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="toggleIsVisiblePwd"
              />
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="3">
              <!-- 登入按鈕 -->
              <v-btn
                x-large
                :loading="loginLoading"
                :disabled="loginLoading"
                color="primary lighten-1"
                block
                class="text-h6 rounded-lg"
                @click="login"
                id="btnLogin">
                {{ $t("login") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-main>

    <v-snackbar
      v-model="formTip"
      multi-line
      top
      color="error">
      {{ formTipText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="formTip = false">
          <icon-close class="cheerfulgive-icon" />
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import Helper from '../helper'
import Api from '../apis'
import ImagesLogo from '@/assets/images/logo.vue'
import IconUser from '@/assets/icons/user.vue'
import IconMail from '@/assets/icons/mail.vue'
import IconLockClosed from '@/assets/icons/lock-closed.vue'
import IconClose from '@/assets/icons/close.vue'

export default {
  name: 'PosLogin',
  components: {
    ImagesLogo,
    IconUser,
    IconMail,
    IconLockClosed,
    IconClose
  },
  data: () => ({
    isVisiblePwd: false, // 密碼是否可見
    ubn: '', // 統編
    email: '', // 電子信箱
    password: '', // 密碼
    formTip: false, // 是否彈出錯誤訊息
    formTipText: '', // 錯誤訊息內容
    loginLoading: false // 是否登入中
  }),
  computed: {
    // 統編規則 & 自動產生編號規則
    ubnRules () {
      return [
        v => !!v || this.$t('pleaseInputUbn'),
        v => (Helper.string.validateUbn(v) || Helper.string.validateCustomUbn(v)) || this.$t('ubnFormatError')
      ]
    },
    // 電子信箱規則
    emailRules () {
      return [
        v => !!v || this.$t('pleaseInputEmail'),
        v => Helper.string.validateEmail(v) || this.$t('emailFormatError')
      ]
    },
    // 密碼規則
    passwordRules () {
      return [
        v => !!v || this.$t('pleaseInputPassword')
      ]
    }
  },
  created () {
    // console.log(process.env.VUE_APP_ENV)
  },
  methods: {
    // 執行登入
    login () {
      this.loginLoading = true

      // 再驗證欄位
      if (!this.$refs.form.validate()) {
        this.formTipText = this.$t('pleaseCheckAllColumns')
        this.formTip = true
        this.loginLoading = false
        return false
      }

      Api.auth.login(this.ubn, this.email, this.password)
        .then(res => {
          // 登入成功檢查權限 (需要有現場登打編輯權限)
          // if (res.data.roles.includes('ROLE_DESK_KEYIN_EDITABLE')) {
          // 寫入所有登入資訊
          const now = new Date().getTime() / 1000

          localStorage.setItem('access_token', res.data.access_token)
          localStorage.setItem('expires_in', res.data.expires_in)
          localStorage.setItem('expires', now + res.data.expires_in)
          localStorage.setItem('refresh_token', res.data.refresh_token)
          localStorage.setItem('roles', res.data.roles)
          localStorage.setItem('token_type', res.data.token_type)
          localStorage.setItem('username', res.data.username)
          this.$router.push('/menu')
          return true
          // }  else {
          // this.formTipText = this.$t('roleError')
          // this.formTip = true
          // return false
          // }
        })
        .catch(() => {
          // 登入失敗
          this.formTipText = this.$t('loginError')
          this.formTip = true
          return false
        })
        .finally(() => {
          this.loginLoading = false
        })
    },
    toggleIsVisiblePwd () {
      this.isVisiblePwd = !this.isVisiblePwd
    }
  }
}
</script>

<style>
.title {
  border-bottom-width: 4px !important;
  border-bottom-style: solid !important;
  border-bottom-color: var(--v-primary-lighten-1) !important;
}
</style>
